import React, { ReactNode, useContext } from 'react';
import classNames from 'classnames';
import { IconProp } from 'models/Icon';
import Counter from 'components/Counter';
import { COLOR_VARIANT } from 'models/Colors';
import { useTranslation } from 'react-i18next';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { TIMEFRAME_FILTER_COPY } from 'router/subrouters/DataRoom/components/TimeframeFilter/data';

import './DashCardHeading.styles.scss';

type DashCardHeadingProps = {
  className?: string;
  heading: ReactNode;
  description?: string;
  numberOfElements?: number;
  showCounter?: boolean;
  showTimeframe?: boolean;
  icon?: IconProp;
};

const DashCardHeading: React.FC<DashCardHeadingProps> = (props) => {
  const {
    className,
    children,
    heading,
    description,
    numberOfElements = 0,
    showCounter = true,
    showTimeframe = true,
    icon: Icon,
  } = props;

  const classes = classNames('dash-card-heading', className);

  const { preferredDashboardTimeframe } = useContext(DataRoomContext);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <div>
        <div className="dash-card-heading__left">
          {Icon && <Icon />}

          <div className="title">{heading}</div>

          {showCounter && (
            <Counter
              count={numberOfElements}
              variant={COLOR_VARIANT.GREY}
              displayEmptyValue
            />
          )}
        </div>

        <div className="dash-card-heading__right">
          {showTimeframe && (
            <p>{t(TIMEFRAME_FILTER_COPY[preferredDashboardTimeframe])}</p>
          )}

          {children}
        </div>
      </div>

      {description && <p className="description">{description}</p>}
    </div>
  );
};

export default DashCardHeading;
